import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveTask = async (uuid: string) => {
  const response = await CustomAxios.post(`tasks/${uuid}/archive`);
  return response.data;
};

interface UseArchiveTaskProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveTask({ uuid, onSuccessCallback }: UseArchiveTaskProps) {
  return useMutation({
    mutationFn: () => archiveTask(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.allTasks, uuid] });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the task. Please try again and contact support if the problem persists.');
      }
    },
  });
}
